var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageDiv"},[_c('v-card',{staticStyle:{"width":"100%","height":"100px"},attrs:{"primary":""}},[_vm._v(" Hello Ben ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }